
<div class="mobile-bottom-nav font-rubik">
  <div class="nav-links-container">
    <div class="ca-logo-container flex items-center justify-center shadow-lg">
      <img src="@/images/header/mobile-bottom-nav/container-alliance-logo-icon.svg" alt="Container Alliance">
    </div>

    <div
      v-for="solution in solutionsArr"
      :key="`mobile-nav-${solution.slug}`"
      :class="['nav-link', isActive(solution.slug) ? 'active' : '']"
      :style="isActive(solution.slug) ? { '--active-color': colorMapping[solution.key] } : {}"
    >
      <a :href="solution.slug" class="nav-link-item flex items-center justify-center">
        <img :src="isActive(solution.slug) ? solution.iconSelected : solution.iconDefault" alt="icon" />
        <span :class="['nav-link-title', isActive(solution.slug) ? 'active' : '']" v-html="solution.title"></span>
      </a>
    </div>
  </div>
</div>
